import styles from '~/styles/pages/demo.css?url'
import formStyles from '~/styles/components/form.css?url'
import reviewCardStyles from '~/components/cards/review-card/review-card.css?url'
import gridStyles from '~/styles/components/grid.css?url'
import { FormBasics } from '~/components/forms/basics'
import { H2, P, Stack } from '~/components-v2'
import { logosGridData3, LogosGridProps } from './_landing/data/logos-grid'
import {
  ActionData,
  handleHubspotFormAction,
  submitToHubspot,
} from '~/utils/hubspot'
import { formSchema } from '~/utils/form-schema'
import { HUBSPOT_PORTAL_ID, HUBSPOT_FORM_ID } from '~/config/form'
import { useActionData } from 'react-router'
export { meta } from '~/utils'
export const links = () => [
  { rel: 'stylesheet', href: formStyles },
  { rel: 'stylesheet', href: reviewCardStyles },
  { rel: 'stylesheet', href: gridStyles },
  { rel: 'stylesheet', href: styles },
]

const title = 'Try Omni with your data'
const description = 'The AI analytics platform trusted by'

export const loader = async () => {
  return { title, description }
}

export const action = handleHubspotFormAction({
  schema: formSchema,
  submitToHubspot,
  formId: HUBSPOT_FORM_ID,
  portalId: HUBSPOT_PORTAL_ID,
  thankYouUrl: '/thankyou',
})

const LOGO_BASE = '/images/pages/landing/request-demo'

const Headings = ({ className = '' }: { className?: string }) => (
  <Stack gap={4} as="hgroup" className={`demo-headings ${className}`}>
    <h1 className="heading-xxl">
      Try Omni
      <br />
      with your data
    </h1>
    <div className="trusted-by">
      <H2 className="trusted-by__label">
        The AI analytics platform trusted by
      </H2>
    </div>
  </Stack>
)

const Logos = ({ logos }: { logos: LogosGridProps[] }) => (
  <ul className="logos-grid" role="list" aria-label="Trusted by">
    {logos.map((logo) => (
      <li key={logo.name} className="logos-grid__item">
        <img
          className="logos-grid__img"
          src={`${LOGO_BASE}/${logo.image}`}
          alt={`${logo.name} logo`}
          loading="lazy"
          decoding="async"
        />
      </li>
    ))}
  </ul>
)

function Component({ children }: { children?: React.ReactNode }) {
  const actionData = useActionData<ActionData>()

  return (
    <Stack className="request-demo-wrapper" gap={6} align="center">
      <section className="demo-hero-section">
        <article className="content">
          <Headings className="demo-headings--desktop" />
          <Logos logos={logosGridData3} />
        </article>
        <div>
          <Headings className="demo-headings--mobile" />
          <div className="demo-page-content">
            <div className="gradients">
              <div className="dawn"></div>
            </div>
            <article className="form">
              {children}
              <FormBasics
                includeDemoFields
                formTitle="Schedule a 1:1 meeting with our team"
                buttonLabel="Request Demo"
                campaignCode="request-demo-cta"
                formCta="Request Demo"
                actionData={actionData}
              ></FormBasics>
            </article>
          </div>
        </div>
      </section>
    </Stack>
  )
}

export default Component

export function ErrorBoundary() {
  return (
    <Component>
      <P
        fontSize="xs"
        fontWeight={500}
        lineHeight={1.5}
        style={{ color: '#c00', paddingBottom: '1.5rem' }}
      >
        We encountered an error while processing your request. Please try again
      </P>
    </Component>
  )
}
